import React, { Component } from 'react'
import mixpanel from './plugin/mixpanel'

import Home from './pages/Home'
import Search from './pages/Search'
import HotelDetails from './pages/HotelDetails'
import Payment from './pages/Payment'

import MyPing from './pages/MyPing'
import BookingDetails from './pages/BookingDetails'
import MyProfile from './pages/MyProfile'
import Referral from './pages/Referral'
import VoucherMenu from './pages/VoucherMenu'
import VoucherDetails from './pages/VoucherDetails'

import About from './pages/About'
import ContactUs from './pages/ContactUs'
import TermsNCondition from './pages/TermsNCondition'
import Privacy from './pages/Privacy'
import FAQ from './pages/FAQ'

import TestPage from './pages/TestPage'
import NotFound from './pages/NotFound'

import {BrowserRouter, Routes, Route} from 'react-router-dom'
import Footer from './components/Footer'

// mixpanel.track('Login Button Clicked');

function App() {
  return (
  <div>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home/>} />
          <Route path="/search/*" element={<Search />} />

          <Route path='/hotel/*' element={<HotelDetails/>} />
          <Route path='/villa/*' element={<HotelDetails/>} />
          <Route path='/homestay/*' element={<HotelDetails/>} />
          <Route path='/cottage/*' element={<HotelDetails/>} />
          <Route path='/resort/*' element={<HotelDetails/>} />
          <Route path='/apartment/*' element={<HotelDetails/>} />
          <Route path='/glamping/*' element={<HotelDetails/>} />

          <Route path="/:lang/payment.html" element={<Payment />} />
          <Route path="/payment.html" element={<Payment />} />
          {/* <Route path="/:type/*" element={<HotelDetails />} /> */}

          <Route path='/myping/*' element={<MyPing/>} />
          <Route path='/bookingdetails/*' element={<BookingDetails/>} />
          <Route path='/myprofile/*' element={<MyProfile/>} />
          <Route path='/referral/*' element={<Referral/>} />
          <Route path='/vouchermenu/*' element={<VoucherMenu/>} />
          <Route path='/voucherdetails/*' element={<VoucherDetails/>} />

          <Route path='/about/*' element={<About/>} />
          <Route path='/contactus/*' element={<ContactUs/>} />
          <Route path='/termsandcondition/*' element={<TermsNCondition/>} />
          <Route path='/privacy/*' element={<Privacy/>} />
          <Route path='/frequentaskquestion/*' element={<FAQ/>} />

          <Route path='/TestPage' element={<TestPage/>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
  </div>
  )
}

export default App  